import { render, staticRenderFns } from "./reviewDocument.vue?vue&type=template&id=1766ae45&scoped=true&"
import script from "./reviewDocument.vue?vue&type=script&lang=js&"
export * from "./reviewDocument.vue?vue&type=script&lang=js&"
import style0 from "./reviewDocument.vue?vue&type=style&index=0&id=1766ae45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1766ae45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1766ae45')) {
      api.createRecord('1766ae45', component.options)
    } else {
      api.reload('1766ae45', component.options)
    }
    module.hot.accept("./reviewDocument.vue?vue&type=template&id=1766ae45&scoped=true&", function () {
      api.rerender('1766ae45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chatbotManagement/components/reviewDocument.vue"
export default component.exports